import { isDefined } from '@sgme/fp';
import type { ChangeEvent, ReactElement } from 'react';
import { Form } from 'react-bootstrap';

type FormSelectBaseProps = string;

type FormSelectProps<T> = {
  values: readonly T[];
  selectedValue: T;
  onChange: (value: T) => void;
  formatValue?: (value: T) => string;
  'data-e2e'?: string;
};

export function FormSelect<T extends FormSelectBaseProps>({
  values,
  selectedValue,
  onChange,
  formatValue,
  'data-e2e': dataE2e,
}: FormSelectProps<T>): ReactElement {
  function getFormattedValue(value: T): string {
    if (isDefined(formatValue)) {
      return formatValue(value);
    }

    return value;
  }

  function handleChange(event: ChangeEvent<HTMLSelectElement>): void {
    const value = values.find((value) => value === event.target.value);

    if (isDefined(value)) {
      onChange(value);
    }
  }

  return (
    <Form.Select size="sm" onChange={handleChange} value={selectedValue} data-e2e={dataE2e}>
      {values.map((value) => (
        <option key={value} value={value}>
          {getFormattedValue(value)}
        </option>
      ))}
    </Form.Select>
  );
}
